import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ToastProvider } from "./shared/ui/Toast";
import { ShortcutsCheatsheet } from "./shared/ui/ShortcutsCheatsheet";
import "./theme.css";

// #19917 đưa route báo cáo về chunk tải sau. Sau một lần deploy, tab đang mở index.html cũ sẽ xin
// chunk theo hash cũ (404) và React gỡ cả cây → màn trắng. Vite phát `vite:preloadError` đúng lúc đó;
// tải lại trang để lấy index.html mới. Chỉ một lần mỗi phiên, để lỗi thật không thành vòng lặp tải lại.
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (sessionStorage.getItem("addy-chunk-reload")) return;
    sessionStorage.setItem("addy-chunk-reload", "1");
  } catch {
    // sessionStorage bị chặn: vẫn tải lại một lần — tệ nhất là thêm một lần tải.
  }
  event.preventDefault();
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
          <ShortcutsCheatsheet />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
